/**
 * В самодельных таблицах есть возможность фиксации некоторых колонок.
 * Эта функция помогает показывть тень от фиксированных колонок, если происходит скроллирование.
 * @param container Общий контейнер
 * @param scrollLeft значение скролла (обычно из события скролла)
 * @param cellClass класс для ячеек, которые могут отбрасывать тень
 * @param overlapClass класс с тенью
 */
export const toggleOverlapClass = (
  container: HTMLElement | null | undefined,
  scrollLeft: number,
  cellClass: string,
  overlapClass: string,
) => {
  container?.querySelectorAll(`.${cellClass}`).forEach((elem) => {
    elem.classList.toggle(overlapClass, scrollLeft > 0.1);
  });
};
